import { FormHelperText, InputAdornment, makeStyles } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import {
	FormDataConsumer,
	Labeled,
	maxLength,
	required,
	TextField,
	TextInput,
	UrlField,
	useNotify,
	useTranslate,
} from "react-admin";
import { CopyToClipboard } from "react-copy-to-clipboard";
import useNetwork from "../../useNetwork";

const useStyles = makeStyles({
	labeled: {
		overflow: "auto",
	},
});

const createLink = (formData, comparatorDomainName) =>
	`${document.location.protocol}//${get(
		formData,
		"domain_name"
	)}.${comparatorDomainName}`;

const CopyableCodeField = ({ content, label }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const classes = useStyles();
	return (
		<div style={{ display: "block", clear: "both", cursor: "copy" }}>
			<Labeled label={translate(label)} className={classes.labeled}>
				<CopyToClipboard
					text={content}
					onCopy={() => notify(translate("ra.action.content_copied"))}
				>
					<TextField source="content" record={{ content }} />
				</CopyToClipboard>
			</Labeled>
			<FormHelperText>{translate("ra.action.click_to_copy")}</FormHelperText>
			<br />
		</div>
	);
};

const CopyableUrlField = ({ url, label }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const classes = useStyles();
	return (
		<Labeled label={translate(label)} className={classes.labeled}>
			<CopyToClipboard
				text={url}
				onCopy={() => notify(translate("ra.action.content_copied"))}
			>
				<UrlField source="url" target="_blank" record={{ url }} />
			</CopyToClipboard>
		</Labeled>
	);
};

const DomainNameInput = ({ validate, disableHelper = false, ...props }) => {
	const { network } = useNetwork();
	const comparatorDomainName = get(network, "comparator_domain_name", "");
	return (
		<FormDataConsumer {...props}>
			{({ formData, ...rest }) => (
				<>
					<TextInput
						{...props}
						validate={[required(), maxLength(100)]}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									{comparatorDomainName}
								</InputAdornment>
							),
						}}
					/>
					{!disableHelper && (
						<>
							<CopyableUrlField
								url={createLink(formData, comparatorDomainName)}
								label={"resources.bonus-comparators.fields.domain_name_preview"}
							/>
							<CopyableCodeField
								label={"resources.bonus-comparators.fields.iframe_link_0"}
								content={`<iframe src="${createLink(
									formData,
									comparatorDomainName
								)}?iframe=true" border="0" style="border:none;width:100%;height:1000px;overflow:auto;"></iframe>`}
							/>
							<CopyableCodeField
								label={"resources.bonus-comparators.fields.iframe_link_1"}
								content={`<iframe src="${createLink(
									formData,
									comparatorDomainName
								)}?banner=3" border="0" style="border:none;width:300px;height:450px;overflow:auto;"></iframe>`}
							/>
							<CopyableCodeField
								label={"resources.bonus-comparators.fields.iframe_link_1"}
								content={`<iframe src="${createLink(
									formData,
									comparatorDomainName
								)}?banner=5" border="0" style="border:none;width:300px;height:710px;overflow:auto;"></iframe>`}
							/>
						</>
					)}
				</>
			)}
		</FormDataConsumer>
	);
};
export default DomainNameInput;
